export const HOME = '/';
// export const PENDING_INBOUND = '/pending-inbound-airbill';
export const PACKAGE_WITHIN = '/package-within';
export const HIGH_VALUE = '/high-value';
export const WITHHELD = '/withheld';
export const CLEARER = 'clearer';
export const PICKLIST = 'picklist';
export const USER = 'user';
export const WAREHOUSE = 'warehouse';
export const CRM = 'crm';
export const WAREHOUSEAREA = 'area';
export const WARAHOUSESTATE = 'state';
export const SETTINGS = 'settings';
export const NOTIFICATION = 'notifications';
// Users
export const ADMINUSER = 'admin-user';
export const CLEARERUSER = 'clearer-user';
export const DISPATCHERUSER = 'dispatcher-user';
export const WAREHOUSEUSER = 'warehouse-user';
//
export const TOKENS = 'tokens';
export const SUPPORT = 'support';
export const ACCOUNT = 'account';
export const SIGNUP = 'signup';
export const SIGNUPCHANGEPASSWORD = 'set-password';
export const SIGNUPCOMPLETE = 'signup-complete';
export const SIGNIN = 'signin';
export const VERIFY_OTP = 'verify-otp';
export const RESET_PASSWORD = 'reset-password';
export const RESET_PASSWORD_VERIFY = 'reset-password/verify';
export const NOTFOUND = '404';
